import { Link, useLocation } from "react-router-dom";
import { Store } from "../../../static/pharma.model";
import { isAndroid, isIOS } from "react-device-detect";
import './signupInfoPharmacy.css'
import { Button } from "primereact/button";
import MapTabComponent from "../../Pharmacy/map-tab/mapTab.component";

type SignupInfoPharmacyProps = {
    pharmacy: Store
}

export default function SignupInfoPharmacy(props: SignupInfoPharmacyProps) {
    
    const location = useLocation()
    const {pharmacy} = props;

    const chiama = (number: string) => {
        if(isAndroid){
            window.location.href = 'tel:' + number;
        }
        else if(isIOS){
            window.location.href = 'telprompt:'+ number;
        }
    };    

    return (
        <>
        <div className="signup-info-pharmacy">
        <div className="vh-100 shadow-2 container-info-pharmacy">
            <div className="flex flex-column">

                {/* {pharmacy.latitude || pharmacy.longitude ?
                    <MapTabComponent default={{lat: pharmacy.latitude, lng: pharmacy.longitude}}/>
                    : <></>
                } */}
                <div className="flex flex-column justify-content-between align-items-center ml-2 mt-1">

                    {/* <div className="w-full flex align-items-center justify-content-center my-5">
                        <div className="box-title ">
                          <i className="pi pi-building mx-1"></i>Farmacia selezionata
                        </div>
                    </div> */}
           

                    <div className="flex flex-column align-items-center gap-3">
                        <div className="flex flex-column gap-1">
                            <div className="col-12 ">
                                <div className="text-xl font-bold mb-3">{pharmacy.name}</div>
                                <div className="info-pharmacy text-lg mb-1 mt-3 flex justify-content-center align-items-center">
                                    <i className="pi pi-map-marker mr-1 " style={{ color: 'var(--primary-color)' }}></i>
                                    {
                                        window.location.pathname !== '/signup' ? (
                                            <span className="info-pharmacy text-lg">{pharmacy.address.address+' '+pharmacy.address.city}</span>
                                        )
                                        :
                                        (
                                            <span className=" signup-info-address text-lg">{pharmacy.address.address+' '+pharmacy.address.city}</span>
                                        )
                                    }
                                </div>
                                {/* <div className='flex justify-content-start flex-wrap '>
                                    <Button size='small' className='style-button-farmacie' style={{width: '120px'}} label='Naviga'
                                        onClick={() => naviga() }>
                                    </Button> 
                                </div> */}
                            </div>
                            
                         
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </>
    )
}